import { SEARCH_SPOT_LISTS_REQUEST, searchSpotListsSuccess, searchSpotListsFailure } from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const searchSpotListsEpic: TEpic = (action$, store$, { SpotListRepository }) => {
    return action$.pipe(
        ofType( SEARCH_SPOT_LISTS_REQUEST ),
        mergeMap(action => from(
            SpotListRepository.findAll(action.payload)
                .then(({ spotLists, meta }) => searchSpotListsSuccess({ spotLists, response: meta, request: action}))
                .catch((error: Error) => searchSpotListsFailure(error)),
        )),
    );
}
